export const apiBaseUrl = 'https://gutmicro.net/api';
export const baseUrl = '';
